import { type ReactNode } from 'react'

import { AiActionBanner } from '../AiActionBanner'
import { AiActionButton } from '../AiActionButton'

interface ILlmConversationConfirmationBannerProps {
  title: ReactNode
  actionContent: ReactNode
  actionAriaLabel?: string
  actionAnalyticsId?: string
  onActionClick?: () => void
}

export const LlmConversationConfirmationBanner = ({
  title,
  actionContent,
  actionAriaLabel,
  actionAnalyticsId,
  onActionClick,
}: ILlmConversationConfirmationBannerProps) => (
  <AiActionBanner
    icon={null}
    action={
      <AiActionButton
        ariaLabel={actionAriaLabel}
        analyticsId={actionAnalyticsId}
        onClick={onActionClick}
      >
        {actionContent}
      </AiActionButton>
    }
  >
    {title}
  </AiActionBanner>
)
